<!-- 
 * @description: 顶部导航模块
 * @fileName: template.vue 
 * @author: 赖雪婷 
 * @date: 2022-04-18 17:13:52
!-->
<template>
  <div>
    <div
      :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mRastarNav': 'RastarNav'"
      v-if="!isForgot"
    >
      <ul class="nav nav-1">
        <li
          @click="searId=2,changeNavMai(2)"
          :class="{active:searId==2}"
        >登錄</li>
        <li
          v-on:click="searId=1,changeNavMai(1)"
          v-bind:class="{active:searId==1}"
        >註冊</li>
      </ul>
      <!-- 登陆 -->
      <rastar-login
        :isForgot="isForgot"
        :appId="appId"
        :pId="pId"
        :mdId="mdId"
        :ukey="ukey"
        :initialization="initialization"
        :system="system"
        v-if="searId==2"
        v-on:forgot="forgot"
      ></rastar-login>
      <!-- 登陆 end -->
      <!-- 注册 -->
      <rastar-register
        v-if="searId==1"
        :appId="appId"
        :pId="pId"
        :mdId="mdId"
        :ukey="ukey"
        :msgVal="msgVal"
        :initialization="initialization"
        :system="system"
      ></rastar-register>
    </div>

    <rasta-forgot
      v-if="isForgot"
      v-on:forgot="forgot"
      :appId="appId"
      :pId="pId"
      :mdId="mdId"
      :ukey="ukey"
      :system="system"
    ></rasta-forgot>

  </div>

</template>

<script>
import rastarRegister from "./../register/template.vue";
import rastarLogin from "./../land/template.vue";
import rastaForgot from "./../forgot/template.vue";

export default {
  name: "RastarNav",
  props: ["appId", "pId", "mdId", "ukey", "msgVal", "initialization", "system"],
  components: {
    rastarRegister,
    rastarLogin,
    rastaForgot,
  },
  data: function () {
    return {
      isForgot: false,
      isShow: false,
      // 默认注册显示
      Index: 1,
      searId: 1,
      flag: 0,
    };
  },
  methods: {
    forgot(val) {
      this.isForgot = val;
    },
    /*
     *@description: 触发埋点上报
     *@author: 赖雪婷
     *@date: 2022-04-18 17:22:23
     */
    changeNavMai(k) {
      if (k == 1) {
        if (this.system === 'PC') {
          this.$Report.webDotFather(
            this.pId,
            this.appId,
            this.ukey,
            "show_pcldy_signup_index"
          );
        } else {
          this.$Report.webDotFather(
            this.pId,
            this.appId,
            this.ukey,
            "show_moldy_signup_index"
          );
        }
      } else {
        if (this.system === 'PC') {
          this.$Report.webDotFather(
            this.pId,
            this.appId,
            this.ukey,
            "show_pcldy_password_login_index"
          );
        } else {
          this.$Report.webDotFather(
            this.pId,
            this.appId,
            this.ukey,
            "show_moldy_password_login_index"
          );
        }
      }
    },
  },
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
